module.exports = __webpack_public_path__ + "static/img/PRULIA_BannerEvents.56b35bf4.jpg";